export default __webpack_public_path__ + "static/media/glr-6.b6e8b2f4.webp";